/**
 * Backend render utility fonksiyonları
 * 
 * Bu fonksiyonlar sadece backend'de (GrapesJS editöründe) render edilirken
 * data-component-path ve data-props gibi attribute'ları eklemek için kullanılır.
 * Frontend'de (PageRenderer.tsx) render edilirken bu attribute'lar görünmemelidir.
 */

/**
 * Backend render için component attribute'larını oluşturur
 * 
 * @param componentPath Component path (örn: 'page_layouts/ProductSearchPageLayout')
 * @param props Component props (JSON string'e çevrilecek)
 * @param isBackendRender Backend'de render ediliyor mu? (__grapesPreview prop'undan alınabilir)
 * @returns Backend render attribute'ları veya boş obje
 */
export function getBackendRenderAttributes(
    componentPath: string,
    props?: Record<string, unknown>,
    isBackendRender?: boolean
): Record<string, string> {
    // Sadece backend render modunda attribute'ları ekle
    if (!isBackendRender) {
        return {};
    }

    const attributes: Record<string, string> = {
        'data-component-path': componentPath,
    };

    // Props varsa JSON string olarak ekle
    if (props && Object.keys(props).length > 0) {
        try {
            // Backend'e özel prop'ları filtrele (__grapesPreview, __pageContext vb.)
            const filteredProps = { ...props };
            delete filteredProps.__grapesPreview;
            delete filteredProps.__pageContext;
            
            // Eğer filtreleme sonrası props kaldıysa ekle
            if (Object.keys(filteredProps).length > 0) {
                attributes['data-props'] = JSON.stringify(filteredProps);
            }
        } catch (error) {
      
        }
    }

    return attributes;
}

/**
 * Component props'undan backend render modunu kontrol eder
 * 
 * @param props Component props
 * @returns Backend render modunda mı?
 */
export function isBackendRenderMode(props?: Record<string, unknown>): boolean {
    if (!props) {
        return false;
    }
    
    // __grapesPreview prop'u varsa ve true ise backend render modu
    return props.__grapesPreview === true;
}
